import moment from "moment";
import userTypes from "venuescanner-js/constants/user_type";
import reasons from "venuescanner-js/constants/decline-reasons.js";

const declineReasons = (thread) => {
  const declineReasons = [
    {
      value: reasons.PRICE,
      label:
        thread.viewerRole === userTypes.host
          ? `The organiser's budget is too low`
          : "Looking for a better price",
    },
    {
      value: reasons.AVAILABILITY,
      label:
        thread.viewerRole === userTypes.host
          ? "Not available"
          : "Venue not available",
    },
    {
      value: reasons.SUITABILITY,
      label:
        thread.viewerRole === userTypes.host
          ? "Not suitable"
          : "Venue not suitable",
    },
    {
      value: reasons.TERMS,
      label: `Couldn't agree on terms`,
    },
    thread.viewerRole === userTypes.organiser
      ? {
          value: reasons.ANOTHERVENUE,
          label: "Found another venue",
        }
      : null,
    {
      value: reasons.NOREPLY,
      label:
        thread.viewerRole === userTypes.host
          ? "Did not reply"
          : "Host did not reply",
    },
    {
      value: reasons.OTHER,
      label: "Other",
    },
  ];
  return declineReasons;
};

export default declineReasons;
